module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-btn"
  }, [(_vm.page == 'main' && _vm.nextLesson.length) ? _c('button', {
    staticClass: "next-level-btn",
    on: {
      "click": _vm.goNextLesson
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("chapter.chanper-btn.continue")) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37bfe9ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter/chapter-btn.vue
// module id = 544
// module chunks = 0